import React from "react";
import { Route, Redirect } from "react-router-dom";
import apis from '../api';
import authenticationService from '../services/authentication.service';
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : PrivateRouteLogin
Description : Pagina de PrivateRouteLogin para permitir acceso a las paginas si el loguin esta correcto.
Date Autor Modification
================================================================================
2/11/2021 Cristian Andres Pizo Mina - Pagina de PrivateRouteLogin.
================================================================================ */
export function PrivateRouteLogin({ component, ...options }) {

    const autenticado = authenticationService.getAuthUser();
    console.log(autenticado)
    //localStorage.removeItem("type")
    return (
        autenticado.token && autenticado.type === "ADMIN"
            ? <Redirect to="/Home" />
            : (autenticado.token && autenticado.type === "CLIENT" ? <Redirect to="/Certificate" /> : <Route {...options} component={component} />)
    )
};


export default PrivateRouteLogin;
